import * as React from 'react';
import { Panel, PanelType, IPanelProps } from 'office-ui-fabric-react';
import { Dictionary, ISourceInfo, PANEL_CUSTOM_WIDTH } from "../../entities/common";
import WorkTogetherTab from "../integration/WorkTogetherTab";
import { SourceType } from "../../store/ExternalEpmConnectStore";
import { ApplicationState } from '../../store';
import { Integrations, Subscription } from '../../store/Tenant';
import { connect } from 'react-redux';
import ContactUsDialog from '../settings/billing/ContactUsDialog';

type OwnProps = {
    readonly: boolean;
    actions: Dictionary<any>;
    sourceInfos: ISourceInfo[]; 
    onDismiss: () => void;
    visibleTypes?: SourceType[];
}
type StateProps = {
    subscription: Subscription;
};

type Props = OwnProps & StateProps;

type State = {
    selectedTab: string;
    selectedType?: SourceType;
    context?: any;
    showContactUsDialog?: boolean;
}

export class ExternalEpmConnectControl extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const integrations = new Integrations(props.subscription.integrations);
        this.state = { selectedTab: "link", selectedType: props.visibleTypes?.find(integrations.isEnabled) }
    }

    public render() {
        return <Panel
            isLightDismiss
            type={PanelType.custom}
            customWidth={PANEL_CUSTOM_WIDTH}
            className="connect-panel"
            isOpen={true}
            onDismiss={this.props.onDismiss}
            onRenderHeader={this._onRenderHeader}>
            <WorkTogetherTab
                {...this.props}
                selected={this.state.selectedType}
                context={this.state.context}
                visibleOptions={this.props.visibleTypes}
                onShowContactUsDialog={() => this.setState({ showContactUsDialog: true })} />
            {this.state.showContactUsDialog && (
                <ContactUsDialog planName='Enterprise' onDismiss={() => this.setState({ showContactUsDialog: false })} />
            )}
        </Panel>;
    }

    private _onRenderHeader = (props?: IPanelProps): JSX.Element | null => {
        return <div className="ms-Panel-header">
            <p className="ms-Panel-headerText">Configure Connections</p>
            <div className='ms-Panel-secondaryText'>Connect to external systems to setup collaboration process.</div>
        </div>;
    }
}


function mapStateToProps(state: ApplicationState): StateProps {
    return {
        subscription: state.tenant.subscription,
    };
}

export default connect(mapStateToProps, {})(ExternalEpmConnectControl);